import avatarEdu from "./avatares/avatar-edu.webp";
import avatarHiro from "./avatares/avatar-hiro.webp";
import avatarLaurinha from "./avatares/avatar-laurinha.webp";
import avatarLulu from "./avatares/avatar-lulu.webp";

// Os 4 avatares são compartilhados por todas as regiões (decisão 22 do backlog
// do protótipo): o aluno escolhe quem ele é, e isso não deve depender da região
// que caiu para a série dele.
//
// `id` != `nome` em dois deles (hiro→Leo, laurinha→Clara), e é deliberado: o id
// é CHAVE, não rótulo. Ele é gravado no progresso local do aluno
// (ava/progressoDoAluno.js), casa com o nome do arquivo de arte
// (conteudo/avatares/avatar-*.webp) e é o valor de `data-avatar` que o CSS usa
// (ver o ajuste de escala do Edu em styles/aberturaTrilha.css). Renomear o id
// junto com o rótulo trocaria o explorador de quem já escolheu — `getAvatar`
// devolveria null e o aluno cairia no padrão sem ter pedido.
export const AVATARES = [
  { id: "lulu", nome: "Lulu", asset: avatarLulu },
  { id: "hiro", nome: "Leo", asset: avatarHiro },
  { id: "edu", nome: "Edu", asset: avatarEdu },
  { id: "laurinha", nome: "Clara", asset: avatarLaurinha }
];

export const AVATAR_PADRAO = AVATARES[2]; // Edu

export function getAvatar(avatarId) {
  return AVATARES.find(avatar => avatar.id === avatarId) ?? null;
}
